export const getAuthClientId = () => {
  return (window as any).authClientId;
};

export const getAuthDomain = () => {
  return (window as any).authDomain;
};
